<div class="app-container">
    <!-- Sidebar -->
    <div class="sidebar">
        <a *ngIf="hasAccess(['Admin', 'StoreAdmin'])" routerLink="/dashboard" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="sidebar-item active">
            <i class="fas fa-chart-line"></i>
            <span>Dashboard</span>
        </a>
        <a *ngIf="hasAccess(['Admin','StoreAdmin', 'StoreUser'])" routerLink="/batchlist" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="sidebar-item">
            <i class="fas fa-layer-group"></i>
            <span>Batch</span>
        </a>
        <a *ngIf="hasAccess(['StoreAdmin'])" routerLink="/user" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="sidebar-item">
            <i class="fas fa-user"></i>
            <span>User</span>
        </a>
        <a *ngIf="hasAccess(['Admin'])" routerLink="/store" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="sidebar-item">
            <i class="fas fa-house"></i>
            <span>Store</span>
        </a>
        <div class="sidebar-version">
            <p>{{ version }}</p>
          </div>
    </div>
</div>